import { Box, Button, Img } from '@chakra-ui/react';
import { useContext, useState } from 'react';

import { ProfileContext } from '../EntirePreview';
import { motion } from 'framer-motion';

type ReviewProps = {
  preloadedAssets: any;
  setIsCompleteReview: any;
  reviewInput: any;
  setReviewInput: any;
  setCompleteTrue: any;
};

const CompletionReview: React.FC<ReviewProps> = ({
  preloadedAssets,
  setIsCompleteReview,
  reviewInput,
  setReviewInput,
  setCompleteTrue,
}) => {
  const ReviewCompletionApi = async () => {
    setReviewInput((prev: any) => ({ ...prev, completeStatus: 'Yes' }));

    setCompleteTrue(true);
    setIsCompleteReview(false);
  };
  const ReviewPromptClose = () => {
    setReviewInput((prev: any) => ({ ...prev, completeStatus: 'No' }));
    setCompleteTrue(false);
    setIsCompleteReview(false);
  };
  return (
    <>
      <Box id="container" className="Play-station">
        <Box className="top-menu-home-section">
          <Box className="Setting-box">
            <motion.div
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 20,
              }}
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <>
                <Img src={preloadedAssets?.Replay} className="setting-pad" />
                <Box className={'complete_propmpt'}>
                  <Box
                    w={'100%'}
                    h={'100%'}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={'space-between'}
                  >
                    <>
                      <Box className="replay_game_text">
                        Review Completion Confirmation
                      </Box>
                      <Box className="replay_game_text">
                        Is your review final? Once you mark this as complete,
                        your feedback will be shared with the creator and no
                        further comments can be added.
                      </Box>
                      <Box
                        display={'flex'}
                        justifyContent={'space-between'}
                        w={'100%'}
                      >
                        <Button background={'transparent !important'}>
                          <Img
                            src={preloadedAssets?.Yes}
                            onClick={() => ReviewCompletionApi()}
                            className="replay_game_btn"
                          />
                        </Button>
                        <Button background={'transparent !important'}>
                          <Img
                            src={preloadedAssets?.No}
                            onClick={() => ReviewPromptClose()}
                            className="replay_game_btn"
                          />
                        </Button>
                      </Box>
                    </>
                  </Box>
                </Box>
              </>
            </motion.div>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CompletionReview;
